function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5,
  fill: "#EF4337",
  stroke: "url(#paint0_linear_3621_32131)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4058 8.03725C12.4097 7.97285 12.4114 7.91125 12.4114 7.85C12.4114 5.72725 10.6544 4 8.49562 4C6.91362 4 5.49052 4.94185 4.88537 6.366C3.47452 6.56235 2.40002 7.689 2.40002 9.01655C2.40002 10.4964 3.71252 11.7 5.32532 11.7H11.6649C12.732 11.7 13.6 10.8453 13.6 9.7946C13.6 9.012 13.1219 8.32705 12.4058 8.03725ZM11.6652 11H5.32532C4.09857 11 3.10002 10.1103 3.10002 9.01655C3.10002 7.9865 4.00337 7.11885 5.15697 7.04115C5.29557 7.0317 5.41597 6.94105 5.46287 6.8098C5.91402 5.54805 7.13272 4.7 8.49527 4.7C10.2684 4.7 11.7111 6.11295 11.7111 7.85C11.7111 7.96795 11.7023 8.09185 11.6834 8.2406C11.661 8.41875 11.7769 8.585 11.9515 8.6256C12.5101 8.75545 12.9 9.236 12.9 9.7946C12.9 10.4592 12.346 11 11.6652 11Z",
  fill: "#FDFDFD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.29764 6.90244C9.16079 6.76559 8.93958 6.76559 8.80273 6.90244L8.00019 7.70499L7.19763 6.90244C7.06078 6.76559 6.83959 6.76559 6.70274 6.90244C6.56589 7.03929 6.56589 7.26049 6.70274 7.39734L7.50529 8.19989L6.70274 9.00244C6.56589 9.13929 6.56589 9.36049 6.70274 9.49734C6.77099 9.56559 6.86059 9.59989 6.95019 9.59989C7.03979 9.59989 7.12938 9.56559 7.19763 9.49734L8.00019 8.69479L8.80273 9.49734C8.87098 9.56559 8.96059 9.59989 9.05019 9.59989C9.13979 9.59989 9.22939 9.56559 9.29764 9.49734C9.43449 9.36049 9.43449 9.13929 9.29764 9.00244L8.49508 8.19989L9.29764 7.39734C9.43449 7.26049 9.43449 7.03929 9.29764 6.90244Z",
  fill: "#FDFDFD"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3621_32131",
  x1: 0,
  y1: 16,
  x2: 16,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.2
})));

function SvgDisconnected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/Disconnected.9416cbdfc5b5c1aa08774e8afcd2bda3.svg";
export { ForwardRef as ReactComponent };